import { type FC, useMemo } from 'react'

import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

type PageGuardPengawasProps = React.HTMLAttributes<HTMLDivElement> & {
  accessibleByPPK?: boolean
}

const PageGuardPSPegawai: FC<PageGuardPengawasProps> = ({
  children,
  accessibleByPPK = false,
}) => {
  const {
    isLoading: isLoadingRole,
    isPegawaiPengawasSekolah,
    isPPKPengawasSekolah,
    leave,
  } = useRoleContext()

  const canAccess = useMemo(() => {
    let allowed = false

    // Allow if the user is Pengawas Sekolah and not Kepala Dinas
    if (isPegawaiPengawasSekolah) allowed = true

    // Allow if the user is both Kepala Dinas and Pengawas Sekolah and the page is accessible by Kepala Dinas
    if (isPPKPengawasSekolah && accessibleByPPK) allowed = true

    return allowed
  }, [accessibleByPPK, isPPKPengawasSekolah, isPegawaiPengawasSekolah])

  if (!isLoadingRole && !canAccess) leave()

  // As the component should not be rendered when still loading the user role, we can just return null
  if (isLoadingRole) return null

  return <>{children}</>
}
export default PageGuardPSPegawai
